
import { Fragment } from "react";
import BulletPoint from "./BulletPoint";
import Heading from "./Heading";
import ReferenceId from "./ReferenceId";
import SummarySection from "./SummarySection";
import SubjectLine from "./SubjectLine";
import NoteSection from "./NoteSection";
import { formatBoldText } from "./TextFormatter";

interface FormattedMessageContentProps {
  content: string;
}

const FormattedMessageContent = ({ content }: FormattedMessageContentProps) => {
  if (!content) return null;
  
  // Split by newlines and format each line
  return (
    <>
      {content.split('\n').map((line, index) => {
        // Format bullet points
        if (line.trim().startsWith('•') || line.trim().startsWith('-') || line.trim().startsWith('*')) {
          const bulletContent = line.trim().substring(1).trim();
          return <BulletPoint key={index} content={bulletContent} />;
        }
        
        // Format headings with format **Heading:**
        if (line.trim().startsWith('**') && line.trim().includes(':**')) {
          const headingMatch = line.trim().match(/^\*\*(.*?):\*\*/);
          if (headingMatch) {
            return <Heading key={index}>{headingMatch[1]}:</Heading>;
          }
        }
        
        // Format all-caps headings (ALL CAPS:)
        if (/^[A-Z\s]+:/.test(line.trim())) {
          return <Heading key={index}>{line.trim()}</Heading>;
        }
        
        // Format reference numbers
        if (line.trim().startsWith('Reference ID:')) {
          return <ReferenceId key={index}>{line.trim()}</ReferenceId>;
        }
        
        // Format SUMMARY section
        if (line.trim().startsWith('SUMMARY:')) {
          return <SummarySection key={index} content={line.trim().substring(8).trim()} />;
        }
        
        // Format Subject line
        if (line.trim().startsWith('Subject:')) {
          return <SubjectLine key={index}>{line.trim()}</SubjectLine>;
        }
        
        // Format NOTE sections
        if (line.trim().startsWith('NOTE:')) {
          return <NoteSection key={index}>{line.trim()}</NoteSection>;
        }
        
        // Empty lines become proper spacing
        if (line.trim() === '') {
          return <div key={index} className="h-2"></div>;
        }
        
        // Regular lines with bold text formatting
        return <div key={index}>{formatBoldText(line)}</div>;
      })}
    </>
  );
};

export default FormattedMessageContent;
